import { colors, fontSize } from '@styles/theme'
import styled from '@emotion/styled/macro'

import { FormControlLabel, Radio } from '@mui/material'

const StyledFormControlLabel = styled(FormControlLabel)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

const Label = styled.b`
  font-size: ${fontSize('lg')};
  font-weight: 500;
`

// This radio button works with single-enum values
const SingleEnumRadio = ({ label, state, name, value, onChange, slots={ label: {} } }) => {
  const isChecked = state?.[name] && state?.[name] === value

  return (
    <StyledFormControlLabel
      label={<Label {...slots?.label}>{label}</Label>}
      control={<Radio sx={{ '& .MuiSvgIcon-root': !isChecked ? { fill: 'grey' } : { fill: colors.statusColors['right_now']('primary') } }} />}
      onChange={onChange}
      checked={isChecked}
      value={value}
      name={name}
    />
  )
}

export { SingleEnumRadio }
